import styled from 'styled-components';
import {
  grayPlaceholder,
  grayLightSphera,
  whiteSphera,
  error,
  supportLemonGreen,
  brandBlack,
  blackSphera
} from 'src/utilities/UIStyles/variables/Colors';

export const ForgotPasswordContainer = styled.section``;

export const Banner = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10% 0 2.5% 0;
  width: 90%;
  margin: auto;

  > h2 {
    font-size: 2.5vw;
    font-weight: bold;
    color: ${brandBlack};
    width: 70%;
  }

  > p {
    color: ${brandBlack};
    font-size: 1.3vw;
    width: 40%;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > h2 {
    }

    > p {
    }
  }

  @media (max-width: 600px) {
    flex-direction: column;
    padding: 25% 0 2.5% 0;
    width: 90%;

    > h2 {
      font-size: 5vw;
      width: 100%;
      margin-bottom: 5%;
    }

    > p {
      font-size: 4vw;
      width: 100%;
    }
  }
`;

export const SecurityRules = styled.div`
  display: flex;
  background-color: #f8f8f9;
  padding: 2.5% 5% 5% 5%;

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    flex-direction: column-reverse;
    padding: 5% 5% 5% 5%;
  }
`;

export const SecurityRulesInfo = styled.div`
  width: 50%;

  > p {
    font-size: 1.2vw;
    color: ${brandBlack};
    margin-bottom: 5%;
    width: 85%;

    > span {
      color: ${supportLemonGreen};
      font-weight: bold;
    }
  }

  > ul {
    margin-left: 3%;

    > li {
      display: flex;
      align-items: center;

      > p {
        color: ${brandBlack};
        font-size: 1.2vw;
        margin-bottom: 1%;
        width: 70%;
      }

      > figure {
        width: 20px;
        height: 20px;

        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > p {
      > span {
      }
    }

    > ul {
      > li {
        > p {
        }

        > figure {
          > img {
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    width: 100%;
    margin-bottom: 10%;

    > p {
      font-size: 4.2vw;
      width: 100%;

      > span {
      }
    }

    > ul {
      > li {
        > p {
          font-size: 4.2vw;
          width: 100%;
        }

        > figure {
          > img {
          }
        }
      }
    }
  }
`;

export const SecurityRulesForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1),
    > div:nth-child(2) {
      > input:nth-child(1) {
      }

      > figure:nth-child(2) {
        > img {
        }
      }
    }

    > input:nth-child(3) {
    }

    > div:nth-child(4) {
      > figure {
        > img {
        }
      }

      > p {
      }
    }

    > p:nth-child(5) {
    }

    > a:nth-child(6) {
    }
  }

  @media (max-width: 600px) {
    width: 100%;

    > div:nth-child(1),
    > div:nth-child(2) {
      > input:nth-child(1) {
        font-size: 4.2vw;
        width: 90%;
      }

      > figure:nth-child(2) {
        > img {
        }
      }
    }

    > input:nth-child(3) {
      font-size: 4.2vw;
      width: 100%;
    }

    > div:nth-child(4) {
      > figure {
        > img {
        }
      }

      > p {
        font-size: 4.2vw;
      }
    }

    > p:nth-child(5) {
      font-size: 4.2vw;
      margin-top: 5%;
      margin-bottom: 2.5%;
    }

    > a:nth-child(6) {
      font-size: 4.2vw;
      width: 100%;
    }
  }
`;

export const EmailForm = styled.div`
  margin-bottom: 5%;

  > input {
    font-size: 1.2vw;
    color: ${grayPlaceholder};
    width: 100%;
    height: 35px;
    margin-bottom: 2.5%;
    padding-left: 2.5%;
    border: 1px solid ${grayLightSphera};
    border-radius: 5px;
  }

  > p {
    color: ${error};
    font-size: 1.2vw;
    text-align: center;
    margin-bottom: 2.5%;

    > a {
      text-decoration: none;
      color: ${error};
      font-weight: bold;
    }
  }

  > button {
    display: block;
    color: ${whiteSphera};
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    width: 50%;
    padding: 2%;
    margin: auto;
    border: none;
    border-radius: 5px;
    background-color: ${brandBlack};
    cursor: pointer;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > input {
    }

    > p {
    }

    > button {
    }
  }

  @media (max-width: 600px) {
    > input:nth-child(1) {
      font-size: 4.2vw;
      width: 90%;
    }

    > p {
      font-size: 4.2vw;
    }

    > button {
      font-size: 4.2vw;
    }
  }
`;

export const ForgotPasswordForm = styled.div`
  > div:nth-child(1) {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: 5px;
    margin-bottom: 2.5%;

    > input {
      font-size: 1.2vw;
      color: ${blackSphera};
      width: 100%;
      height: 35px;
      padding-left: 2.5%;
      border: 1px solid ${grayLightSphera};
      border-radius: 5px;
      background-color: ${whiteSphera};

      :focus {
        outline: none;
      }
    }
  }

  > div:nth-child(2),
  > div:nth-child(3) {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 1px solid ${grayLightSphera};
    border-radius: 5px;
    background-color: ${whiteSphera};
    margin-bottom: 2.5%;

    > input {
      font-size: 1.2vw;
      color: ${blackSphera};
      width: 92%;
      height: 35px;
      padding-left: 2.5%;
      border: none;
      border-radius: 5px;

      :focus {
        outline: none;
      }
    }

    > figure:nth-child(2) {
      width: 25px;
      height: 25px;
      cursor: pointer;
      margin-right: 1%;

      > img {
        width: 100%;
        height: 100%;
      }
    }

    > figure:nth-child(3) {
      width: 25px;
      height: 20px;
      cursor: pointer;
      margin-right: 1%;

      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  > button {
    display: block;
    font-size: 1rem;
    font-weight: bold;
    color: ${whiteSphera};
    width: 50%;
    height: 50px;
    margin: 5% auto;
    border: none;
    border-radius: 5px;
    background-color: ${brandBlack};
    cursor: pointer;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1) {
      > input {
        :focus {
        }
      }
    }

    > div:nth-child(2),
    > div:nth-child(3) {
      > input {
        :focus {
        }
      }

      > figure:nth-child(2) {
        > img {
        }
      }

      > figure:nth-child(3) {
        > img {
        }
      }
    }

    > button {
    }
  }

  @media (max-width: 600px) {
    > div:nth-child(1) {
      > input {
        font-size: 4.2vw;

        :focus {
          outline: none;
        }
      }
    }

    > div:nth-child(2),
    > div:nth-child(3) {
      > input {
        font-size: 4.2vw;

        :focus {
        }
      }

      > figure:nth-child(2) {
        > img {
        }
      }

      > figure:nth-child(3) {
        > img {
        }
      }
    }

    > button {
      width: 90%;
    }
  }
`;

export const PasswordMatch = styled.p`
  font-size: 1.2vw;
  font-weight: bold;
  color: ${error};
  text-align: center;
  border: 1px solid red;

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    font-size: 4.2vw;
  }
`;
